var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9298",
    "data-name": "Group 9298",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u062D\\u0633\\u0627\\u0628_\\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC",
    "data-name": "\\u062D\\u0633\\u0627\\u0628 \\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H24V24H0Z",
    fill: "none",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9299",
    "data-name": "Group 9299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8921",
    "data-name": "Group 8921",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M11.556,10.111a3.556,3.556,0,1,1,3.556-3.556A3.556,3.556,0,0,1,11.556,10.111Z",
    transform: "translate(-3.556 -3)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask-Copy",
    d: "M3,19.4c.345-4.242,3.788-6.4,7.985-6.4,4.256,0,7.752,2.038,8.013,6.4a.611.611,0,0,1-.668.711H3.647A.984.984,0,0,1,3,19.4Z",
    transform: "translate(-3 -4.111)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWhite);
export default __webpack_public_path__ + "static/media/person_white.3e1e7a629aeda3b708ae530ea7fbc087.svg";
export { ForwardRef as ReactComponent };